import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';

const StyledComponent = styled<any, any>('div', 'modalActions', 'modal')`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    margin: '10px 0 0 0',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Modal/StyledComponents/ModalActions.tsx